'use strict';

import './PlansAdditionalInfo.less';

import React from 'react';

export default class PlansAdditionalInfo extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			show: false
		};
	}

	render() {

		const { show } = this.state;

		let BULLETS =  [ {
					KEY: 'bullet-1',
					ANSWER: '<div class="emoji">🕹</div><div class="name">Memberships</div> You have a choice of coding courses to select from: Minecraft, Roblox or Bundle (both products at a discount). Every membership contains access to all our courses, including any future updates.'
				},
				{
					KEY: 'bullet-2',
					ANSWER: '<div class="emoji">⏰</div><div class="name">Monthly subscription</div> Our monthly subscription provides access until the same time one calendar month later. The plan will automatically renew unless you cancel auto-renewal.'
				},
				{
					KEY: 'bullet-3',
					ANSWER: '<div class="emoji">📆</div><div class="name">Annual subscription</div> Our annual subscription provides you access for one calendar year. The plan will automatically renew unless you cancel.'
				},
				{
					KEY: 'bullet-4',
					ANSWER: '<div class="emoji">👍</div><div class="name">Lifetime membership</div> Lifetime memberships have no time limited access and no future billing. You’ll have access to all future content as it\'s released.'
				},

				{
					KEY: 'bullet-5',
					ANSWER: '<div class="emoji">👨‍👩‍👧‍👦</div><div class="name">Family plans</div> A Family membership includes 5 users instead of 1, perfect for households with more than one young coder. Each user has their own unique login and coding progression. Additionally for our Minecraft product each user is provided with their own private Minecraft server. You are welcome to gift & share spare account slots to friends outside of your household.'
				},

				{
					KEY: 'bullet-6',
					ANSWER: "<div class=\"emoji\">💰</div><div class=\"name\">Refunds</div> We offer a 30 day refund policy for all our annual and lifetime plans, starting from the date you (or whoever you gift too) starts using Code Kingdoms. This gives you a chance to try out our product with a safety net given that these accounts cost a fair bit more upfront than our monthly plans. I'm afraid we don't offer this policy on our monthly subscriptions."
				},

				{
					KEY: 'bullet-7',
					ANSWER: '<div class="emoji">⤴️</div><div class="name">Upgrading</div> You can upgrade at any time to a different membership. You won’t be refunded for any previous purchases when you upgrade to a different membership length, but you will if you upgrade to Family or Bundle. So if you think the annual or lifetime memberships may be for you but are worried about your child not liking Code Kingdoms, remember we offer a 30-day refund policy on those memberships.'
				},

				{
					KEY: 'bullet-8',
					ANSWER: '<div class="emoji">💪</div><div class="name">Easy cancel</div> Cancelling your monthly or annual plan is easy and can be done from your account page in less than 30 seconds. There is no need to contact customer support. And yes, you can cancel auto-renewal at any time and your membership will still be accessible to the end of the period you paid for.'
				},

				{
					KEY: 'bullet-10',
					ANSWER: '<div class="emoji">🎁</div><div class="name">Gifts</div> Any membership can be sent as a gift after you purchase.'
				},

				{
					KEY: 'bullet-11',
					ANSWER: '<div class="emoji">👌</div><div class="name">PayPal</div> PayPal is supported for annual and lifetime plans.'
				},
	
			];



		return (

			

			<div  className={`PlansAdditionalInfo ${show ? 'active' : ''}`}>
				<div className="header" onClick={() => this.setState({ show: !show })}>Click here to learn the difference between our plan options</div>
				<div className={`info ${show ? 'active' : ''}`}>

					
				{BULLETS.map(bullet => {

						return (
							<div key={bullet.KEY}  className="bullet" dangerouslySetInnerHTML={{ __html: bullet.ANSWER }} ></div>
						);
					})}
				</div>
			</div>
		);
	}
}
